export function parseBulkCsv(text: string): { studentId: string; name: string; class: string; section: string; pickupMethod: string }[] {
  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const rows: { studentId: string; name: string; class: string; section: string; pickupMethod: string }[] = [];
  const headerLike = /^(studentId|name|class|section|pickup)/i;
  for (let i = 0; i < lines.length; i++) {
    const parts = lines[i].split(',').map((p) => p.replace(/^"|"$/g, '').trim());
    if (parts.length < 3) continue;
    if (i === 0 && headerLike.test(parts[0])) continue;
    const [studentId, name, classVal, section = '', pickupMethod = 'PARENT_PICKUP'] = parts;
    if (!studentId || !name || !classVal) continue;
    rows.push({
      studentId,
      name,
      class: classVal,
      section,
      pickupMethod: (pickupMethod && pickupMethod.trim()) ? pickupMethod.trim() : 'PARENT_PICKUP',
    });
  }
  return rows;
}
